// WCAG AA-compliant color constants (origin: ADO #32625).
//
// Single source of truth for accessible colors used in React inline styles,
// where sass variables (see src/sass/abstracts/variables.scss) cannot reach.
// Keep these values in sync with the $*-accessible / $*-dark sass variables.
//
// The decorative brand colors (#5F9EC5 blue, #CC5967 red, #E48148 orange) fail
// WCAG 1.4.3 (4.5:1) when used as text on light surfaces; these darker variants
// pass. Use the *Dark variants only for text painted on dark backgrounds.

/** Brand blue as text on light surfaces — >=4.78:1 (was #5F9EC5 @ 2.77:1). */
export const linkColorAccessible = "#3A6E91";

/** Brand blue as text on dark backgrounds — >=4.78:1. */
export const linkColorDark = "#7FB4D4";

/** Reject/error red as text on light surfaces — >=4.88:1 (was #CC5967 @ 4.04:1). */
export const linkRejectAccessible = "#B83A48";

/** Reject/error red as text on dark backgrounds — >=5.09:1. */
export const linkRejectDark = "#E68A95";

/** Urgent orange as text on light surfaces — >=4.80:1 (was #E48148 @ 2.79:1). */
export const urgentColorAccessible = "#A85A1C";

/** Muted grey as text on light surfaces — >=4.77:1 (was #919194 @ 3.14:1). */
export const greyTextAccessible = "#6D6F72";
